import React from 'react';
import { User } from 'lucide-react';
interface HeaderProps {
  title: string;
}
export function Header({
  title
}: HeaderProps) {
  return <header className="bg-white border-b border-gray-200 px-8 py-4" data-id="element-12">
      <div className="flex items-center justify-between" data-id="element-13">
        <h2 className="text-2xl font-semibold text-gray-900" data-id="element-14">{title}</h2>
        <div className="flex items-center gap-4" data-id="element-15">
          <div className="flex items-center gap-3" data-id="element-16">
            <div className="text-right" data-id="element-17">
              <p className="text-sm font-medium text-gray-900" data-id="element-18">Admin User</p>
              <p className="text-xs text-gray-500" data-id="element-19">admin@ekseba.com</p>
            </div>
            <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center" data-id="element-20">
              <User className="w-5 h-5 text-white" data-id="element-21" />
            </div>
          </div>
        </div>
      </div>
    </header>;
}